import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
        Pragma: "no-cache",
      },
    };
  }

  static getStatuses() {
    return axios.get(ENV.dealerBaseUrl + "/app_statuses/list", this.requestConfig());
  }

  static saveStatus(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/app_statuses/update", requestData, this.requestConfig());
  }
}

export default Service;
